import { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import api, { apiErr } from "@/lib/api";
import { ArrowLeft, Loader2 } from "lucide-react";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) {
      toast.error(apiErr(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-background p-8">
      <div className="w-full max-w-sm animate-fade-up">
        <h1 className="font-display text-3xl font-bold">Mot de passe oublié</h1>
        {sent ? (
          <p className="mt-4 text-sm text-muted-foreground" data-testid="forgot-confirmation">
            Si cet e-mail est enregistré, un lien de réinitialisation vient de vous être
            envoyé. Vérifiez votre boîte de réception.
          </p>
        ) : (
          <>
            <p className="mt-2 text-sm text-muted-foreground">
              Saisissez votre e-mail pour recevoir un lien de réinitialisation.
            </p>
            <form onSubmit={submit} className="mt-8 space-y-4">
              <input
                data-testid="forgot-email"
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full border border-border bg-transparent px-3 py-2.5 text-sm outline-none transition-colors focus:border-primary"
                placeholder="vous@entreprise.com"
              />
              <button
                type="submit"
                disabled={loading}
                data-testid="forgot-submit"
                className="flex w-full items-center justify-center gap-2 bg-primary px-4 py-2.5 text-sm font-medium text-primary-foreground transition-colors duration-200 hover:bg-primary/90 disabled:opacity-60"
              >
                {loading && <Loader2 size={16} className="animate-spin" />}
                Envoyer le lien
              </button>
            </form>
          </>
        )}
        <Link
          to="/login"
          className="mt-6 flex items-center gap-2 text-sm text-muted-foreground hover:text-foreground"
          data-testid="back-to-login"
        >
          <ArrowLeft size={16} /> Retour à la connexion
        </Link>
      </div>
    </div>
  );
}
